import React , {useState, useRef, useEffect} from "react";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import Swal from "sweetalert2";
import Str from "./Str";
import SkeletonVideoPlayer from "../../loaders/SkeletonVideoPlayer";

export const TakePhoto = (props) => {
    function handleCameraStart(stream) {
        // console.log('handleCameraStart');
    }

    function handleCameraStop() {
        // console.log('handleCameraStop');
    }

    return (
        <Camera
            onTakePhoto={props.handleTakePhoto}
            onTakePhotoAnimationDone={props.handleTakePhotoAnimationDone}
            onCameraError={props.handleCameraError}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            imageType={IMAGE_TYPES.JPG}
            imageCompression={0.97}
            isMaxResolution={true}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStart={(stream) => { handleCameraStart(stream); }}
            onCameraStop={() => { handleCameraStop(); }}
        />
    )

};


export class CameraFeed extends React.Component {
    constructor(props) {
        super(props);
        this.showCamFeedRef = React.createRef();
        this.contextRef = null;
        this.currentStream = null;
        this.isProcessing = false; 
        this.state = {
            hasPermission: '',
            loading : true,
        };
    }

    cleanupStream() {
        if (this.currentStream) {
            this.currentStream.getTracks().forEach(track => {
                track.stop();
            });
            this.currentStream = null;
        }
        if (this.videoPlayer) {
            this.videoPlayer.srcObject = null;
        }
    }
    processDevices(devices) {
        const videoDevices = devices.filter(dev => dev.kind=="videoinput")
        videoDevices.forEach(device => {
            this.setDevice(device);
        });
    }

    async setDevice(device) {
        if (this.isProcessing) return;
        this.isProcessing = true;
        try {
            const { deviceId } = device;
            if (deviceId) {
                if (!deviceId) {
                    throw new Error('No device ID provided');
                }
                this.cleanupStream();
                const stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId } })
                this.currentStream = stream;
                if (this.videoPlayer) {
                    this.videoPlayer.srcObject = stream;
                    await new Promise((resolve, reject) => {
                        this.videoPlayer.onloadedmetadata = async () => {
                            try {
                                await this.videoPlayer.play();
                                this.setState({ loading: false });
                                resolve();
                            } catch (playError) {
                                reject(playError);
                            }
                        };

                        setTimeout(() => reject(new Error('Video load timeout')), 3000); // NEW: Shorter timeout
                    });
                }
            }
        } catch (error) {
            console.error('Camera setup error:', error); // NEW: Better error logging
            this.setState({
                hasPermission: 'no',
                loading: false
            });
        } finally {
            this.isProcessing = false; // NEW: Always unlock
        }

    }

    async componentDidMount() {
        if (this.isProcessing) return;
        this.isProcessing = true;  
        try {
            // Get camera stream
            const stream = await navigator.mediaDevices.getUserMedia({
                video: true
            });
            this.currentStream = stream;

            this.videoPlayer.srcObject = stream;

            // Wait for the video to actually be ready and playing
            await new Promise((resolve, reject) => {
                this.videoPlayer.onloadedmetadata = () => {
                    this.videoPlayer.play()
                        .then(() => {
                            this.setState({
                                hasPermission: 'yes',
                                loading: false
                            });
                            resolve();
                        })
                        .catch(reject);
                };

                // Add timeout to prevent hanging
                setTimeout(() => reject(new Error('Camera timeout')), 30000);
            });
            if (this.canvas && !this.contextRef) {
                this.contextRef = this.canvas.getContext('2d', {
                    willReadFrequently: true
                });
            }

        } catch (error) {
            console.error('Camera access failed:', error);
            this.setState({
                hasPermission: 'no',
                loading: false
            });
        } finally {
            this.isProcessing = false; 
        }

    }


    componentWillUnmount() {
        this.cleanupStream();
        this.contextRef = null;
        this.isProcessing = false;
    }

    takePhoto = async () => {
        if (this.isProcessing) return;
        this.isProcessing = true;
        try {
            const stream = this.videoPlayer.srcObject;
            if (stream && stream.active) {
                const { sendFile } = this.props;
                requestAnimationFrame(() => {
                    try {
                        this.contextRef.drawImage(this.videoPlayer, 0, 0, 680, 360);

                        // NEW: Compressed JPEG instead of PNG (60% smaller files)
                        const dataURL = this.canvas.toDataURL('image/jpeg', 0.8);
                        sendFile(dataURL);
                    } catch (drawError) {
                        console.error('Photo capture failed:', drawError);
                    }
                });
            }
            else {
                this.setState({ hasPermission: 'no' })
                const cameras = await navigator.mediaDevices.enumerateDevices();
                this.processDevices(cameras);
            }
        } finally {
            setTimeout(() => {
                this.isProcessing = false;
            }, 500);
        }
    };

    render() {
        return (
            <>
                {<h1 className="cam-permission">{(this.state.hasPermission == 'yes') ? '' : (this.state.hasPermission == 'no') ? Str.noCamPermission : ''}</h1>}
                {<div className={`c-camera-feed`}>
                    <div className={`c-camera-feed__viewer  ${this.props.showCamFeed ? '' : 'student-card-image-blk-mobile'}`}>
                        {!this.state.loading && <i onClick={this.takePhoto} className={this.state.hasPermission == 'yes' ? "fal fa-camera" : this.state.hasPermission == 'no' ? "fal fa-redo" : ''}></i>}
                        <video playsInline muted ref={ref => (this.videoPlayer = ref)} width="680" height="360" />
                    </div>

                    <div className="c-camera-feed__stage student-card-image-blk-mobile">
                        <canvas width="680" height="360" ref={ref => (this.canvas = ref)} />
                    </div>
                </div>}
                {this.state.loading && <SkeletonVideoPlayer/>}
            </>
        );
    }
}

